import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef,Output, EventEmitter,  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { EducationService } from '../../services/education.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-education-view',
  templateUrl: './education-view.component.html',
  styleUrls: ['./education-view.component.scss']
})
export class EducationViewComponent {
@ViewChild('eventRef') eventRef: ElementRef;
@Output() selectClass = new EventEmitter < any > ();

results: any = [];
eventlist: any = [];
color: any = 'blue';

 constructor(private educationService: EducationService, private globalSearchService: GlobalSearchService, private route: ActivatedRoute, private modalService: NgbModal) {
		this.color = this.globalSearchService.getColor();
	}
	
	ngOnInit(){
		
		this.getEvents();
	}
	
	getEvents(){
		this.educationService.getEvents().subscribe((a) => {
			this.results = a;
			if (this.results) {
				this.results.forEach((evt) => {
					if(!evt.expired){
					this.eventlist.push(evt);
					}
				});
				
			}
			
		});
	}
	
	showEvents() {
			this.modalService.open(this.eventRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {
				
			});
		
	}
	
	addClass(item: any){
	const data = {stockid: item};
	this.selectClass.emit(data);
	}
}
